export default __webpack_public_path__ + "static/media/bannerImage_v2.dcbe5f29.png";